module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0de80419b1d8d06b4bfd91b91ad98063.png";